export const currenciesData = [
  {
    value: "USD",
    symbol: "$",
  },
  {
    value: "EUR",
    symbol: "€",
  },
  {
    value: "YEN",
    symbol: "¥",
  },
  {
    value: "NGN",
    symbol: "₦",
  },
  {
    value: "INR",
    symbol: "₹",
  },
  {
    value: "RUB",
    symbol: "₽",
  },
  {
    value: "BTC",
    symbol: "₿",
  },
  {
    value: "ETH",
    symbol: "Ξ",
  },
];
